import {
  useGetRecordingQuery,
  useGetRevisionsQuery,
  useUpdateRecordingMutation,
} from '@carboncopyco/data';
import { PermissionAction, PermissionKey } from '@carboncopyco/types';
import {
  LoadingDots,
  TextBase,
  TextCaption,
  TextLargeParagraph,
} from '@carboncopyco/ui';
import { dateUTCFromNow } from '@carboncopyco/utils';
import { usePermissionsContext } from '../../../utils';
import { TitleCard } from '../../InfoPageCards/TitleCard';
import { InfoPageEditableDescription } from '../../InfoPageEdiableDescription';
import { useClonePageProps } from '../ClonePageContext';

export const DetailsCard = () => {
  const { organizationId, cloneId } = useClonePageProps();
  const { getPermissions } = usePermissionsContext();
  const { data: clone } = useGetRecordingQuery({
    organizationId,
    id: cloneId,
  });
  const { data } = useGetRevisionsQuery({
    organizationId,
    sourceType: 'record',
    id: String(cloneId),
    reverseOrder: true,
  });
  const [updateClone] = useUpdateRecordingMutation();
  const { description } = clone || {};
  const revisions = data?.items;
  const latestVersion = revisions?.[0];
  const updateClonePermission = getPermissions(
    PermissionKey.record,
    PermissionAction.updateRecordingById
  );

  return (
    <TitleCard
      header={
        <div className="flex justify-between items-center">
          <TextLargeParagraph
            color="text-ds-natural-700"
            label="Details"
          />
        </div>
      }
      radius
      padding="xl"
    >
      {clone && revisions ? (
        <div className="flex flex-col gap-7">
          <div className="flex flex-col gap-2">
            <TextCaption label="Description" />
            <div className="max-w-ds-96">
              <InfoPageEditableDescription
                description={description || 'No description available'}
                disabled={!updateClonePermission}
                onDescriptionChange={(value) =>
                  value
                    ? updateClone({
                        organizationId,
                        id: String(cloneId),
                        description: value,
                      })
                    : undefined
                }
              />
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <TextCaption label="Version" />
            {latestVersion && (
              <div className="flex items-center gap-1">
                <TextBase
                  color="text-ds-natural-600"
                  label={`Version ${latestVersion.currRevision + 1}`}
                />
                <TextBase
                  color="text-ds-natural-300"
                  label={`(Edited ${dateUTCFromNow(
                    latestVersion.createTime
                  )}, by ${latestVersion.creator.name})`}
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center h-ds-29">
          <LoadingDots />
        </div>
      )}
    </TitleCard>
  );
};
